import { Logger } from '../../../02_utils/logger';
import { Utils } from '../../../02_utils/utils';

export class SidePanelService {
  constructor(private $log: Logger, private $utils: Utils) {}

  public openSidePanel(sidePanel: HTMLElement): void {
    const body = document.querySelector('body');

    this.$utils.addOrRemoveClases('add', 'open', body);
    this.$utils.addOrRemoveClases('add', 'open', sidePanel);
    this.$utils.addOrRemoveClases('add', 'js-panel-backdrop-element', sidePanel);
    this.$utils.activateFlyoutPanelBackdrop();
  }

  public closeSidePanel(sidePanel: HTMLElement): void {
    const body = document.querySelector('body');

    this.$utils.addOrRemoveClases('remove', 'open', body);
    this.$utils.addOrRemoveClases('remove', 'open', sidePanel);
    this.$utils.deactivateFlyoutPanelBackdrop();
  }
}
